import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ConfigService } from '../../config.service';
import { FwDeleteReasonComponent } from '../../shared/components/fw-delete-reason/fw-delete-reason.component';

export interface DeleteDialogData {
  title?: string
  content?: string
}

export interface DeleteDialogResult {
  delete: boolean
  deleteReason?: string
}

@Component({
  selector: 'delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss'],
  host: {
    'class': 'mat-dialog-component',
    'test-id': 'delete-dialog',
  },
})
export class DeleteDialogComponent {
  public title: string
  public content = 'Are you sure you want to delete [container|analysis|file]?'
  public auditTrailEnabled = false

  @ViewChild('deleteReason', { 'static': true }) deleteReasonSelect: FwDeleteReasonComponent

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: DeleteDialogData = {},
    private configService: ConfigService,
    public dialogRef: MatDialogRef<DeleteDialogComponent, DeleteDialogResult>,
  ) {
    this.title = data.title;
    this.content = data.content || this.content;
    this.auditTrailEnabled = this.configService.isFeatureEnabled('audit_trail');
  }

  canDelete(): boolean {
    return !this.auditTrailEnabled || Boolean(this.auditTrailEnabled && this.deleteReasonSelect?.valid);
  }

  cancel(): void {
    this.dialogRef.close({
      delete: false,
      deleteReason: null,
    });
  }

  delete(): void {
    if (!this.canDelete()) {
      return;
    }
    this.dialogRef.close({
      delete: true,
      deleteReason: this.auditTrailEnabled && this.deleteReasonSelect.valid ? this.deleteReasonSelect.value : null,
    });
  }
}
